import { logout } from "@/api/base";

export default {
  common: {
    login: '登录',
    search: '搜索内容',
    please: '请输入',
    noMore: '没有更多了',
    loading: '加载中'
  },
  validation: {
    emailRequired: '请输入邮箱',
    passwordRequired: '请输入密码',
    captchaRequired: '请输入验证码',
    emailFormat: '请输入正确的邮箱格式',
    confirmPasswordRequired: '请再次输入密码',
    nicknamePlaceholder: '设置昵称',
    nicknameRequired: '请设置昵称',
    avatarTip: '设置头像',
    avatarRequired: '请上传头像'
  },
  login: {
    emailPlaceholder: '输入邮箱',
    passwordPlaceholder: '输入密码',
    captchaPlaceholder: '输入验证码',
    forgot: '忘记密码?',
    goRegister: '立即注册',
    logout: '退出登录'
  },
  register: {
    title: '注册账号',
    emailPlaceholder: '输入邮箱',
    codePlaceholder: '输入验证码',
    getCode: '获取验证码',
    passwordPlaceholder: '输入密码',
    confirmPlaceholder: '确认密码',
    nicknamePlaceholder: '设置昵称',
    setAvatar: '设置头像',
    submit: '注册',
    uploading: '上传中...'
  },
  forgot: {
    title: '找回密码',
    emailPlaceholder: '输入邮箱',
    codePlaceholder: '输入验证码',
    getCode: '获取验证码',
    passwordPlaceholder: '输入密码',
    confirmPlaceholder: '确认密码',
    submit: '确认',
    noMatch: '两次输入密码不一致'
  },
  contact: {
    title: '欢迎联系',
    infoTitle: '联系我们',
    namePlaceholder: '你的名字',
    nameRequired: '请输入名字',
    emailPlaceholder: '你的邮箱',
    companyPlaceholder: '公司名字',
    phonePlaceholder: '你的电话',
    contentPlaceholder: '信息内容',
    captchaPlaceholder: '输入验证码',
    submit: '发送消息',
    submitSuccess: '消息发送成功'
  },
  mine: {
    myLikes: '我的点赞'
  }
}
